export const fmtMoney = (n, currency = "AUD") =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency }).format(Number(n || 0));

// 2026-02-26 — Optional `tz` argument routes the format through the
// venue's IANA timezone. When omitted, behaviour is unchanged (browser
// local TZ — used by legacy callers / driver mobile app).
export const fmtTime = (iso, tz) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleTimeString("en-AU", {
    hour: "2-digit", minute: "2-digit",
    ...(tz ? { timeZone: tz } : {}),
  });
};

export const fmtDate = (iso, tz) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-AU", {
    day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    ...(tz ? { timeZone: tz } : {}),
  });
};

export const minutesSince = (iso) => {
  if (!iso) return 0;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
};
